import React from 'react'

function CoursePageHero() {
  return (
    <div className='flex flex-col pt-[50px] items-center px-[20px]'>
      <p className='font-raleway font-[800] text-[32px] text-center  lg:text-[40px]'>Development Courses</p>
      <p className='text-center text-[16px]  font-[500] mt-[10px] lg:mt-0 font-lato '>Professional and personal development classes to expand your <br className='hidden lg:block'/> skillsets, gain insights and apply immediately.</p>
    </div>
  )
}

export default CoursePageHero